export var UserRole;
(function (UserRole) {
    UserRole["UnivercityStudent"] = "univercity-student";
    UserRole["UnivercityAdmin"] = "univercity-admin";
    UserRole["Prospect"] = "prospect";
    // ... TODO: Add more roles
})(UserRole || (UserRole = {}));
